export default __webpack_public_path__ + "static/media/CBN.9c96666e.webp";